import { useCallback, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import { t } from "@/i18n-js/instance";
import { TextSelect } from "@/react/components/shared/TextSelect";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { BUTTON_DEFAULT_DATA, BUTTON_TYPE_OPTIONS } from "./constants";
import type { ButtonType } from "./constants";
import { isButtonType } from "./typePredicate";

export const ButtonTypePicker = () => {
  const { data, updateSelectedBlock } = useBuilderStore(state => ({
    data: state.getSelectedBlock(),
    updateSelectedBlock: state.updateSelectedBlock,
  }));
  const selectedBlock = data?.block;

  const isButtonBlock = useMemo(
    () => !!selectedBlock && isButtonType(selectedBlock.type),
    [selectedBlock],
  );

  const handleButtonTypeChange = useCallback(
    (newType: ButtonType) => {
      if (!selectedBlock) return;

      const defaultData = BUTTON_DEFAULT_DATA[newType];

      updateSelectedBlock({
        ...selectedBlock,
        id: uuidv4(),
        type: newType,
        meta: defaultData.meta,
        props: {
          ...selectedBlock.props,
          text: selectedBlock.props.text,
          styles: defaultData.props.styles,
        },
      });
    },
    [selectedBlock, updateSelectedBlock],
  );

  if (!isButtonBlock || !selectedBlock) return null;

  const buttonType = selectedBlock.type as ButtonType;

  return (
    <div>
      <TextSelect
        options={BUTTON_TYPE_OPTIONS}
        value={buttonType}
        onChange={handleButtonTypeChange}
        placeholder={t("builder_ui.prop_type.button_type")}
        buttonClassName="w-full"
      />
    </div>
  );
};
